export default __webpack_public_path__ + "static/fluxies-6e403ee90c83dd7ce74ecddd9eafba7f.png";